import React from 'react';

const Hero = () => {
  return (
    <section className="bg-[#F2F4FF] w-full py-10 md:py-30 overflow-hidden">
      <div className="container max-w-[1400px] mx-auto px-4 sm:px-6">

        <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-4 overflow-hidden">
          <div className="">
            <h1 className="text-[30px] sm:text-[30px] lg:text-[48px] font-medium leading-tight tracking-tightest bg-gradient-to-r from-[#6A10CB] to-[#256FFA] bg-clip-text text-transparent mb-6 md:mb-8 font-inter">
              Master Competitive Exams with India's Best Online Learning Platform
            </h1>

            <p className="text-[18px] sm:text-[18px] text-[#00000099] font-medium leading-relaxed mx-auto lg:mx-0 tracking-tight">
              Access comprehensive courses, live interactive classes, thousands of mock tests, and personalized study plans for UPSC, SSC, Banking, JEE, NEET and 50+ other exams.
            </p>
          </div>

          <div className="relative overflow-hidden">
            <div className="bg-[#E9D5FF]/70 rounded-full blur-2xl -z-10 rotate-6 lg:rotate-12"></div>
            <div className="relative w-full max-w-[520px] mx-auto aspect-[4/3.4] md:aspect-[5/4] overflow-hidden rounded-2xl">
              <img
                src={require("../../assets/hero-banner.png")}
                alt="Student mastering competitive exams with BaapBola"
                className="w-full h-full object-cover object-center transition-transform duration-500 hover:scale-105"
                loading="eager"
              />
            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;
